import React from 'react'
import T from 'prop-types'
import Timing from '../hoc/Timing'

/**
 * Wrapper component that delays initial rendering of its children until after a specified
 * `delay` has passed. Can optionally render a `placeholder` in place of the children during
 * the delay period.
 *
 * This can sometimes be useful in postponing expensive renders to allow other performance-
 * sensitive processes to complete, for instance allowing animations to complete without jank.
 */
class DelayRender extends React.Component {
  static propTypes = {
    delay: T.number.isRequired, //delay time in milliseconds
    placeholder: T.any, //optional content to render before delay has elapsed
    setTimer: T.func //from Timing HOC
  }

  state = {
    ready: false
  }

  componentDidMount () {
    this.props.setTimer(() => {
      this.setState({ready: true})
    }, this.props.delay, 'x')
  }

  render () {
    return this.state.ready
      ? this.props.children
      : (this.props.placeholder || null)
  }
}

export default Timing(DelayRender)
